import jsonToFormData from 'json-form-data';

export default class Utils {
  /**
   * Converts given object to a FormData instance recursively
   */
  static objectToFormData (obj) {
    return jsonToFormData(obj);
  }

  /**
   * Returns an array with active days based on given date range.
   */
  static activeDaysInRange (dateFrom, dateTo) {
    let output = [true, true, true, true, true, true, true];
    let startDate = new Date(dateFrom.getTime());
    startDate.setHours(0);
    startDate.setMinutes(0);
    startDate.setSeconds(0);
    startDate.setMilliseconds(0);
    let endDate = new Date(dateTo.getTime());
    endDate.setHours(0);
    endDate.setMinutes(0);
    endDate.setSeconds(0);
    endDate.setMilliseconds(0);

    while (startDate.getTime() <= endDate.getTime()) {
      let dayIndex = new Date(startDate).getDay();

      if (dayIndex > 0) {
        dayIndex = dayIndex - 1;
      } else {
        dayIndex = 6;
      }

      output[dayIndex] = false;
      startDate = new Date(startDate);
      startDate.setDate(startDate.getDate() + 1);
    }

    return output;
  }
  /**
   * Returns date in format YYYY-MM-DD from Date object
   */
  static dateToString (dateObject) {
    return [
      dateObject.getFullYear(),
      dateObject.getMonth() + 1,
      dateObject.getDate()
    ].map(value => {
      if (value < 10) {
        value = '0' + value;
      }

      return value;
    }).join('-');
  }

  /**
   * Returns date object from string in format YYYY-MM-DD
   */
  static stringToDate (dateString) {
    dateString = dateString.split('-').map(value => parseInt(value, 10));
    return new Date(dateString[0], dateString[1] - 1, dateString[2]);
  }
};



// WEBPACK FOOTER //
// ./src/components/helpers/Utils.js